module.exports = __webpack_public_path__ + "static/media/choosing_en.44c0fac5.svg";